import React from 'react';

import { SquareChevronDown } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function DropdownFieldIcon(props: SimpleIconInterface): JSX.Element {
  const { className, dataCy, height, stroke, strokeWidth, style, width } = props;

  return (
    <SquareChevronDown
      className={className}
      data-cy={dataCy}
      height={height ?? 18}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      style={style}
      width={width ?? 18}
    />
  );
}
